var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TableEmptyState"},[_c('div',{staticClass:"TableEmptyState__inner"},[_c('NoDataIcon'),_c('div',{staticClass:"TableEmptyState__label"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('table_selected_empty')))]})],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }